export default {
  select(state, item) {
    state.selected = item;
  },

  deselect(state) {
    state.selected = null;
  },
};
